import { render, staticRenderFns } from "./UsersHubSelector.vue?vue&type=template&id=3dd5f078&"
import script from "./UsersHubSelector.vue?vue&type=script&lang=js&"
export * from "./UsersHubSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports